<template>
    <div class="MarketingPlanDetail">
		<tabs type="primary" 
			:activeTab="strCurrentTab"
			@change="OnTabChange"
            tabContentClasses="tab-opt"
            centered
            inline
            round	
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain">
			<tab-pane :id="'main'" v-if="this.$GVO.my_profile.adm == 1">
			    <template v-slot:label>
			        <span class="tab-label">
			            <span>Общие настройки</span>
			        </span>
			    </template>
				
				<card>
					<h4>Задайте общие настройки</h4>
					<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
				</card>
			</tab-pane>
			<tab-pane :id="'prices'" v-if="this.$GVO.my_profile.adm == 1 && id>0">
				<template v-slot:label>
					<span class="tab-label">
			            <span>Цены</span>
			        </span>
				</template>

				<h3 class="mb-2">{{ info.name }} <span v-if="!info.act">(Отключено)</span> <span v-if="info.autoplan">(АВТОПОДАЧА)</span></h3>
				<h6>Продолжительность подачи: {{ info.days }}</h6>
				<card>
					<!--
					<div  class="d-flex justify-content-between">
						<div>
						</div>
						<div class="mb-1 text-right" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1">
							<base-button @click="AddNewPrice()" type="primary" simple>Добавить цену</base-button>
						</div>
					</div>
					-->
					<table style="width:100%" class="pricetable">
						<tr>
							<!-- <th>Код</th> -->
							<th>Вкл</th>
							<th>Правило</th>
							<th>Цена продажи</th>
							<th>Цена аренды</th>
							<th></th>
							<th>Автоматическое</th>
						</tr>
						<tr v-for="(row,index) in ApiDataTable" :key="index" :class="{disabled: !row.act}">
							
							<!-- <td>{{ row.id }}</td> -->
							<td>
								<p>id {{ row.id }}</p>
								<base-switch :key="row.id"
									v-model="row.act"
									type="primary"
									on-text="Вкл"
									off-text="Выкл"
									@change="ChangeAct(row)"
								></base-switch>
							</td>				
							<td>
								<ReObjFilter
									:catalogs_list="'region'"
									v-model="row.filters"
									:showType="false"
									@input="RowChange(row,$event)"
								/>
							</td>
							<td><ReInputAmount v-model="row.price_sell" mask="money" placeholder="Продажа" :positiveOnly="true"  @input="RowChange(row, $event)"/></td>
							<td><ReInputAmount v-model="row.price_rent" mask="money" placeholder="Аренда" :positiveOnly="true"  @input="RowChange(row, $event)" /></td>
							<td>
								<el-tooltip content="Управление доступами к пакетам" placement="top">
									<el-button class="no-border my-0">
										<button class="btn btn-icon btn-simple btn-info" @click="GoAccessEdit(row)">
											<i class="tim-icons icon-settings-gear-63"></i>
										</button>											
									</el-button>
								</el-tooltip>								
							</td>
							<td>
								<base-switch :key="row.id"
									v-model="row.autoplan"
									type="primary"
									on-text="Вкл"
									off-text="Выкл"
									@change="ChangeAutoplan(row)"
								></base-switch>
							</td>
							<td>
								<base-button @click="apply(row)" :disabled="!row.changed" class="my-0 btn btn-icon btn-simple btn-success"><i class="tim-icons icon-book-bookmark"></i></base-button>
							</td>
						</tr>
					</table>
					<div  class="d-flex justify-content-between">
						<div>
							<base-button @click="applyAll()" :disabled="!hasChanged" class="mb-0 mt-2 btn btn-simple btn-success">Сохранить всё</base-button>
						</div>
						<div class="mb-1 text-right" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1">
							<base-button @click="AddNewPrice()" type="primary" simple>Добавить цену</base-button>
						</div>
					</div>

				</card>
			</tab-pane>
			<tab-pane :id="'sites'" v-if="this.$GVO.my_profile.adm == 1 && id>0">
				<template v-slot:label>
					<span class="tab-label">
			            <span>Площадки</span>
			        </span>
				</template>
				
				<MarketingSitesGroup></MarketingSitesGroup>
								
			</tab-pane>
		</tabs>
    </div>
</template>

<script>
import ReObjFilter from '../../our_components/ReObjFilter.vue';
import { TabPane, Tabs, BaseSwitch } from 'src/components';
import ReInputAmount from '../../our_components/ReInputAmount.vue';
import ReFormPrinter from '../../our_components/FormPrinter/ReFormPrinter.vue';
import MarketingSitesGroup from './MarketingSitesGroup.vue';
import { Button } from 'element-ui';
import tabsMixin from '../../mixins/tabs.js'

export default {
	name: 'MarketingPlanDetail-page',
	mixins: [tabsMixin],
	components: {
        [Button.name]: Button,
		ReObjFilter,
		TabPane, 
		Tabs,		
		BaseSwitch,
		ReInputAmount,
		ReFormPrinter,
		MarketingSitesGroup,
	},
	props: {
	},
	data() {
		return {
			strCurrentTab: 'main', // base_conf||packages
			masAllFormParams: [],
			currentApiFormMethod: {},
			info:{},
			ApiDataTable: [],
			masObjects_total: 0,

		};
	},
	watch:{
		id(val){
			this.getDetailData();
			this.getApiData();
		}
	},
	computed: {
        id(){ return this.$route.params.plan_id },
		hasChanged(){
			for(let r of this.ApiDataTable){
				if(r.changed) return true;
			}
			return false;
		},
	},
	methods: {
		async applyAll(){
			for(let row of this.ApiDataTable){
				if(row.changed) await this.apply(row);
			}
		},
		apply(row){
			// if(row.autoplan===false) row.autoplan=0;
			return this.$GVO.ApiCall(row.id>0?'marketing_plan.INSUPD':'marketing_plan.INS',{flt:{id:row.id},iData:row}).then(result=>{
				if(result.success == true){
					// console.log('Ok');
					if(result.new_id>''){
						this.$set(row, 'id', result.new_id);
					}
					this.$set(row, 'changed', false);
				}else{
					// console.log(result);
				}
			})
		},
		getDetailData(){
			this.$GVO.ApiCall('marketing_plan.GET_NEW',{flt:{id: this.id}})
			.then((objApi) => {
				this.ApiData = [];
				this.masObjects_total=0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.info = objApi.data[0];
					}else{
						this.info={};
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.masApi_total=0; this.ApiData = [];});
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				// filter = this.objGetParams;
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			this.$GVO.ApiCall('marketing_plan.GET',{flt:{ /*'act':1,*/ ...filter, group:this.id, c2p:100}})
			.then((objApi) => {
				this.ApiData = [];
				this.masObjects_total=0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiDataTable = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.ApiDataTable=[];
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.masApi_total=0; this.ApiData = [];});
		},
		AddNewPrice(){
			this.ApiDataTable.push({
				id:0,
				act:1,
				group_id: this.id,
				filters: '[]',
				price_rent: '',
				price_sell: '',
				// name: '',
			});
		},
		ChangeAct(row){
			// console.log('auto');
			this.RowChange(row);
		},
		ChangeAutoplan(row){
			// console.log('auto');
			this.RowChange(row);
		},
		RowChange(row,event){
			// console.log('changed',event);
			this.$set(row, 'changed', true);
		},

		confirmLeave() {
			return window.confirm('Вы не сохранили изменения. Уходим?')
		},

		confirmStayInDirtyForm() {
			return this.hasChanged && !this.confirmLeave()
		},

		beforeWindowUnload(e) {
			if (this.confirmStayInDirtyForm()) {
				// Cancel the event
				e.preventDefault()
				// Chrome requires returnValue to be set
				e.returnValue = ''
			}   
		},
		tabChange(strTabId){
			if(strTabId=='prices'){
				this.getDetailData();
			}		
		},
		// OnTabChange(strTabId){
		// 	let url = new URL(location);
		// 	url.searchParams.set('tab',strTabId);
		// 	this.$router.replace({path: url.search});
		// 	// console.log(strTabId)
		// 	if(strTabId=='prices'){
		// 		this.getDetailData();
		// 	}
		// },
		currentFormConfig() {
			this.$GVO.ApiCall('marketing_plan.GET_GROUP_FORM_MODEL',{flt:{'result_id': this.id}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},		
		currentApiFormMethodComp(){
            return {apiMethod:'marketing_plan.GROUP_INSUPD',apiParam:{iData:[],flt:{'id': this.id}}};
        },
		SuccessGo(evt,dopParam){
	        // console.log('dop',dopParam);
			if(this.id==0 && dopParam.new_id>''){
				this.$router.replace({path: dopParam.new_id});
			}else{
				this.$router.back();
			}
		},
		GoAccessEdit(row){
			if(row.id != null){
				this.$router.push({path: `/data/module/mo/marketing_plan/access_edit/${row.id}`});
			}
		},
	},
	created() {
		window.addEventListener('beforeunload', this.beforeWindowUnload)
	},

	beforeDestroy() {
		window.removeEventListener('beforeunload', this.beforeWindowUnload)
	},	
	mounted() {
		// var queryParams = new URLSearchParams(window.location.search);
		// // queryParams.set("dSearchType", "mobj");
		// history.replaceState(null, null, "?"+queryParams.toString());
		// this.objGetParams = this.$GVO.GetAllGet();
		let url = new URL(location);
		if(url.searchParams.has('tab'))
			this.strCurrentTab = url.searchParams.get('tab');
		this.getDetailData();
		this.getApiData();
		this.masAllFormParams = this.currentFormConfig();
		this.currentApiFormMethod = this.currentApiFormMethodComp();
	},

};
</script>
<style scoped>
.MarketingPlanDetail tr{
	transition:0.5s;
}
.MarketingPlanDetail tr.disabled{
	opacity:0.25;
}
.MarketingPlanDetail >>> .nav-pills .nav-item .nav-link { padding: 1px 23px;}
.pricetable td {padding-right: 10px;}

.MarketingPlanDetail >>> .bootstrap-switch {
    width: 70px !important;
    margin: 0;
}
.MarketingPlanDetail >>> .bootstrap-switch-container {
    width: 106px !important;
}

</style>
